export default "__VITE_ASSET__FEwq1kLV__"